import style from "assets/jss/material-dashboard-pro-react/views/createWireTransferStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { withArtifex } from "core";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { GenericSelectInput, GenericTextInput } from "views/Components/Generic";

class OrderingClientDetail extends Component {
   constructor(props) {
      super(props);

      this.SortedCountry = { Member: "OrderIndex" };
   }

   RenderCountry = (data) => `${data.ISO2} - ${data.Name}`;

   render() {
      const {
         Disabled,
         ValueChanged,
         OrderingClientName,
         SendingFI,
         SendingFISwiftCode,
         SendingFIAddress,
         SendingFICountryId,
         OrderingAddressLine1,
         OrderingAddressLine2,
         OrderingZipCode,
         OrderingCityId,
         OrderingProvinceId,
         OrderingCountryId,
         OrderingSourceAccountNumber,
         InternationalBankCountryId,
         IsDomestic,
      } = this.props;
      return (
         <GridContainer>
            <GridItem xs={12}>
               <GridContainer style={{ borderRadius: 5 }}>
                  <GridItem xs={12}>
                     <h4 style={{ color: "black" }}>
                        <b>Ordering Client Information</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingClientName"
                        LabelText="Ordering Client Name"
                        Value={OrderingClientName}
                        ValueChanged={ValueChanged}
                        Disabled={Disabled}
                        inputProps={{ maxLength: 256 }}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        Name="OrderingCountryId"
                        LabelText="Ordering Country"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                        Parameter={{}}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Code"
                        Value={OrderingCountryId}
                        ValueChanged={ValueChanged}
                        Sorted={this.SortedCountry}
                        RenderItem={this.RenderCountry}
                        Disabled={Disabled}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        key={OrderingCountryId + "province"}
                        Name="OrderingProvinceId"
                        LabelText="Ordering Province"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireProvinces"
                        Parameter={{ Id: OrderingCountryId ?? 0 }}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Name"
                        Value={OrderingProvinceId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "Name" }}
                        Disabled={Disabled}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        VirtualizedList
                        key={"city" + OrderingProvinceId + "" + OrderingCountryId}
                        Name="OrderingCityId"
                        LabelText="Ordering City"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCities"
                        Parameter={{ Id: OrderingProvinceId ?? 0 }}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Name"
                        Value={OrderingCityId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "Name" }}
                        Disabled={Disabled}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingAddressLine1"
                        LabelText="Ordering Address Line 1"
                        Id="ordering-street-address1"
                        Value={OrderingAddressLine1}
                        ValueChanged={ValueChanged}
                        Disabled={Disabled}
                        inputProps={{ maxLength: 256 }}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingAddressLine2"
                        LabelText="Ordering Address Line 2"
                        Id="ordering-street-address2"
                        Value={OrderingAddressLine2}
                        ValueChanged={ValueChanged}
                        Disabled={Disabled}
                        inputProps={{ maxLength: 256 }}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingZipCode"
                        LabelText="Ordering Postal Code"
                        Id="ordering-postcode"
                        Value={OrderingZipCode}
                        ValueChanged={ValueChanged}
                        Disabled={Disabled}
                        inputProps={{ maxLength: 20 }}
                        Required
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingSourceAccountNumber"
                        LabelText="Ordering Source Account Number"
                        Value={OrderingSourceAccountNumber}
                        ValueChanged={ValueChanged}
                        Disabled={Disabled}
                        inputProps={{ maxLength: 50 }}
                        Required
                     />
                  </GridItem>
               </GridContainer>
            </GridItem>
            <GridItem xs={12}>
               <GridContainer style={{ borderRadius: 5 }}>
                  <GridItem xs={12}>
                     <h4 style={{ color: "black" }}>
                        <b>Sending Financial Institution Information</b>
                     </h4>
                  </GridItem>
               </GridContainer>
            </GridItem>
            <GridItem xs={12}>
               <GenericSelectInput
                  Name="InternationalBankCountryId"
                  LabelText="International Bank Country"
                  Method="POST"
                  Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                  Parameter={{}}
                  DataRoot="Item"
                  KeyValueMember="Id"
                  TextValueMember="Code"
                  Value={InternationalBankCountryId}
                  ValueChanged={ValueChanged}
                  Sorted={this.SortedCountry}
                  RenderItem={this.RenderCountry}
                  Disabled={Disabled}
                  Required={IsDomestic ? false : true}
               />
            </GridItem>
            <GridItem xs={12}>
               <GenericTextInput
                  Name="SendingFI"
                  LabelText="Sending Financial Institution"
                  Value={SendingFI}
                  ValueChanged={ValueChanged}
                  Disabled={Disabled}
                  inputProps={{ maxLength: 50 }}
                  Required
               />
            </GridItem>
            <GridItem xs={12}>
               <GenericTextInput
                  Name="SendingFISwiftCode"
                  LabelText="Sending FI Swift Code (BIC)"
                  Value={SendingFISwiftCode}
                  ValueChanged={ValueChanged}
                  Disabled={Disabled}
                  inputProps={{ maxLength: 50 }}
                  Required={IsDomestic ? false : true}
               />
            </GridItem>
            <GridItem xs={12}>
               <GenericTextInput
                  Name="SendingFIAddress"
                  LabelText="Sending FI Address"
                  Value={SendingFIAddress}
                  ValueChanged={ValueChanged}
                  Disabled={Disabled}
                  inputProps={{ maxLength: 256 }}
                  Required
               />
            </GridItem>
            <GridItem xs={12}>
               <GenericSelectInput
                  Name="SendingFICountryId"
                  LabelText="Sending FI Country"
                  Method="POST"
                  Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                  Parameter={{}}
                  DataRoot="Item"
                  KeyValueMember="Id"
                  TextValueMember="Code"
                  Value={SendingFICountryId}
                  ValueChanged={ValueChanged}
                  Sorted={this.SortedCountry}
                  RenderItem={this.RenderCountry}
                  Disabled={Disabled}
                  Required
               />
            </GridItem>
         </GridContainer>
      );
   }
}

OrderingClientDetail.propTypes = {
   classes: PropTypes.object.isRequired,
   Disabled: PropTypes.bool,
   ValueChanged: PropTypes.func,
   OrderingClientName: PropTypes.string,
   SendingFI: PropTypes.string,
   SendingFISwiftCode: PropTypes.string,
   SendingFIAddress: PropTypes.string,
   SendingFICountryId: PropTypes.number,
   OrderingAddressLine1: PropTypes.string,
   OrderingAddressLine2: PropTypes.string,
   OrderingZipCode: PropTypes.string,
   OrderingCityId: PropTypes.number,
   OrderingProvinceId: PropTypes.number,
   OrderingCountryId: PropTypes.number,
   OrderingSourceAccountNumber: PropTypes.string,
   InternationalBankCountryId: PropTypes.number,
   IsDomestic: PropTypes.bool,
};

export default withArtifex(OrderingClientDetail, style);
